import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Info = styled.h2`
	font-style: normal;
	font-weight: 600;
	font-size: 16px;
	line-height: 22px;
	display: flex;
	justify-content: center;
	width: 100%;
	color: ${tokens.color_primary};
	margin: 24px 0;
`;

export const ActionContainer = styled.div`
	display: flex;
	gap: 40px;
`;
